import "./WorkCartStyles.css";

import React from 'react';
import { NavLink } from 'react-router-dom';

const WorkCart = (props) => {

  const { imgsrc, title, text, view, source } = props;

  return (
    <div className='project-card'>
      <img src={imgsrc} alt="Foo eating a sandwich." />
      <h2 className='prject-title'>{title}</h2>
      <div className='pro-details'>
        <p>{text}</p>
        <div className='pro-btns'>
          <NavLink to={view} className="btn">View</NavLink>
          <NavLink to={source} className="btn">Source</NavLink>
        </div>
      </div>
    </div>
  )
}

export default WorkCart
